import React, { useState, useEffect } from 'react';
import { Offcanvas } from 'react-bootstrap';
import ArticleHttp from 'pages/article-page/article.service';
import './article.css';

interface PropsType {
  handleModal: any;
  isShow: boolean;
}

const ArticleView: React.FC<PropsType> = ({ handleModal, isShow }) => {
  const [articles, setArticles] = useState<any>([]);
  const [articleView, setArticleView] = useState<boolean>(false);
  const [selectedArticle, setSelectedArticle] = useState<any>({});

  useEffect(() => {
    if (!isShow || articles.length > 0) return;

    const fetchArticles = async () => {
      try {
        const data = await ArticleHttp.getArticle();
        setArticles(data.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchArticles();
  }, [isShow, articles.length]);

  return (
    <Offcanvas
      show={isShow}
      onHide={() => handleModal(false)}
      placement="end"
      className="article-offcanvas"
    >
      {/* ── Header ── */}
      <Offcanvas.Header
        closeButton
        closeVariant="white"
        className="article-offcanvas-header"
      >
        <div>
          {articleView && (
            <a
              href="#"
              className="article-back-btn"
              onClick={(e) => {
                e.preventDefault();
                setArticleView(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="13"
                viewBox="0 0 24 24"
                width="13"
                fill="currentColor"
              >
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z" />
              </svg>
              Back
            </a>
          )}
          {/* <p className="article-header-eyebrow">
            {articleView ? 'Reading' : 'Knowledge Hub'}
          </p> */}
          <h1 className="article-header-title">
            {articleView ? 'Reading Article' : 'Articles'}
          </h1>
        </div>
      </Offcanvas.Header>

      {/* ── Body ── */}
      <Offcanvas.Body className="article-offcanvas-body">
        <div className="article-scroll-area">

          {/* ════════ LIST VIEW ════════ */}
          {!articleView ? (
            <>
              {articles?.length > 0 && (
                <span className="article-count-label">
                  {articles.length} Article{articles.length !== 1 ? 's' : ''}
                </span>
              )}

              {articles?.length > 0 ? (
                articles.map((article: any, index: number) => (
                  <a
                    key={index}
                    href="#"
                    className="article-card"
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedArticle(article);
                      setArticleView(true);
                    }}
                  >
                    {/* Thumbnail */}
                    <div className="article-card-thumb">
                      {article?.attributes?.thumbnail?.data?.attributes?.url ? (
                        <img
                          src={article.attributes.thumbnail.data.attributes.url}
                          alt={article?.attributes?.title}
                        />
                      ) : (
                        <div className="article-card-thumb-placeholder">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="22"
                            viewBox="0 0 24 24"
                            width="22"
                            fill="rgba(153,131,77,0.38)"
                          >
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" />
                          </svg>
                        </div>
                      )}
                    </div>

                    {/* Text */}
                    <div className="article-card-content">
                      <h3 className="article-card-title">
                        {article?.attributes?.title}
                      </h3>
                      <div
                        className="article-card-excerpt"
                        dangerouslySetInnerHTML={{
                          __html:
                            article?.attributes?.content
                              ?.split(' ')
                              ?.slice(0, 20)
                              ?.join(' ') + '…',
                        }}
                      />
                    </div>

                    {/* Arrow */}
                    <div className="article-card-arrow">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="16"
                        viewBox="0 0 24 24"
                        width="16"
                      >
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path
                          className="article-card-arrow-icon"
                          d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
                        />
                      </svg>
                    </div>
                  </a>
                ))
              ) : (
                <div className="article-empty-state">
                  <div className="article-empty-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                      fill="rgba(153,131,77,0.45)"
                    >
                      <path d="M0 0h24v24H0z" fill="none" />
                      <path d="M19 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V6h10v2z" />
                    </svg>
                  </div>
                  <p className="article-empty-text">No articles available</p>
                </div>
              )}
            </>
          ) : (
            /* ════════ DETAIL VIEW ════════ */
            <div>
              <div className="article-detail-meta">
                {/* <span className="article-detail-pill">Article</span> */}
              </div>

              <h2 className="article-detail-title">
                {selectedArticle?.attributes?.title}
              </h2>

              {selectedArticle?.attributes?.thumbnail?.data?.attributes?.url && (
                <img
                  className="article-detail-hero"
                  src={selectedArticle.attributes.thumbnail.data.attributes.url}
                  alt={selectedArticle?.attributes?.title}
                />
              )}

              <hr className="article-detail-divider" />

              <div
                id="previewDiv"
                dangerouslySetInnerHTML={{
                  __html: selectedArticle?.attributes?.content,
                }}
              />
            </div>
          )}

        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ArticleView;